import { render, staticRenderFns } from "./ActiveIntegrations.vue?vue&type=template&id=35236f20&scoped=true&"
import script from "./ActiveIntegrations.vue?vue&type=script&lang=js&"
export * from "./ActiveIntegrations.vue?vue&type=script&lang=js&"
import style0 from "./ActiveIntegrations.vue?vue&type=style&index=0&id=35236f20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35236f20",
  null
  
)

export default component.exports